import React, { useMemo } from 'react';
import { ApplicationView } from '@aha-app/mvc';
import styles from './Toolbar/Toolbar.module.css';
import type Tool from '../tools/Tool';
import 'tippy.js/dist/tippy.css';
import type { ToolArgsWithController } from '../tools/Tool';

interface WithHintProps {
  tool: typeof Tool;
  toolArgs: ToolArgsWithController;
  children: React.ReactNode;
}

// Optionally display a hint
const WithHint: React.FC<WithHintProps> = ({ tool, toolArgs, children }) => {
  const name = tool.tooltip(toolArgs);
  const shortcut = tool._shortcut?.pretty;
  const placement = tool.tooltipPlacement(toolArgs);

  const content = useMemo(() => {
    return (
      <span>
        {name}{' '}
        {shortcut && (
          <span className={styles.hintToolShortcut}>{shortcut}</span>
        )}
      </span>
    );
  }, [name, shortcut]);

  if (tool && name) {
    return (
      <>
        <span>{children}</span>
        <aha-tooltip
          show-delay={500}
          popover="manual"
          click-hide
          placement={placement}
        >
          {content}
        </aha-tooltip>
      </>
    );
  }

  return <>{children}</>;
};

export default ApplicationView(WithHint);
